export enum PaymentType {
  Check = "Check",
  CreditCard = "CreditCard",
  Cash = "Cash",
  Other = "Other",
}
